import { forwardRef } from 'react';
import clsx from '@/lib/clsx';

const WizardLeftPanel = forwardRef(({ children, className = '', ...props }, ref) => {
  return (
    <div ref={ref} className={clsx('comp-wizard-left-panel', className)} {...props}>
      {children}
    </div>
  );
});

WizardLeftPanel.displayName = 'WizardLeftPanel';

export default WizardLeftPanel;
